import React from "react";
import App from "./app/app";
import { createRoot } from "react-dom/client";

const elementId = "commercial-self-service";

const container = document.getElementById(elementId);

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

//Can turn off for dev as this can result in duplicate elements
const useStrict = true;

if (useStrict) {
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
} else {
    root.render(<App />);
}

